import { useLayoutEffect } from "react";
import {
  removeStylePropertyIfSet,
  scheduleResizeUpdate,
  setStylePropertyIfChanged,
} from "../utils/resizeObserverSafe";

/**
 * Sets --app-sticky-top from the real navbar bottom edge so sidebars stick below it.
 */
export function useSidebarScrollHeight(enabled = true) {
  useLayoutEffect(() => {
    if (!enabled) {
      removeStylePropertyIfSet(document.documentElement, "--app-sticky-top");
      return undefined;
    }

    const root = document.documentElement;

    const update = () => {
      if (window.innerWidth < 960) {
        removeStylePropertyIfSet(root, "--app-sticky-top");
        return;
      }

      const navbar = document.querySelector(".peer-navbar");
      if (!navbar) return;

      const stickyTop = Math.ceil(navbar.getBoundingClientRect().bottom);
      setStylePropertyIfChanged(root, "--app-sticky-top", `${stickyTop}px`);
    };

    const scheduleUpdate = scheduleResizeUpdate(update);

    scheduleUpdate();

    const navbar = document.querySelector(".peer-navbar");
    const observer = navbar ? new ResizeObserver(scheduleUpdate) : null;
    if (navbar) observer.observe(navbar);

    window.addEventListener("resize", scheduleUpdate);

    return () => {
      scheduleUpdate.cancel?.();
      observer?.disconnect();
      window.removeEventListener("resize", scheduleUpdate);
      removeStylePropertyIfSet(root, "--app-sticky-top");
    };
  }, [enabled]);
}
